export function formatLocalVersion(value: unknown): string {
  if (!value) return 'Unknown app version'

  // New format: { appSha: string, sha: string, ts: number }
  if (typeof value === 'object') {
    try {
      const maybe = value as { ts?: unknown; sha?: unknown; appSha?: unknown }
      const ts = typeof maybe.ts === 'number' ? maybe.ts : Number(maybe.ts)
      const sha = typeof maybe.sha === 'string' ? maybe.sha : ''
      if (!Number.isFinite(ts)) return 'Unknown app version'
      const d = new Date(ts)
      const pad = (n: number) => String(n).padStart(2, '0')
      const dd = pad(d.getUTCDate())
      const MM = pad(d.getUTCMonth() + 1)
      const YY = String(d.getUTCFullYear()).slice(-2)
      const hh = pad(d.getUTCHours())
      const mm = pad(d.getUTCMinutes())
      const time = `${hh}:${mm}Z ${dd}.${MM}.${YY}`
      const appSha = typeof maybe.appSha === 'string' ? maybe.appSha : ''
      return [time, sha, appSha].filter(Boolean).join(' ')
    } catch {
      return 'Unknown app version'
    }
  }

  // Legacy format: already a displayable string
  if (typeof value === 'string') return value

  return 'Unknown app version'
}
